export const IntegrationStatusTypes = {
  NOT_CONNECTED: "NOT_CONNECTED", // Не подключена
  CONNECTED: "CONNECTED", // Подключена
  DISCONNECTED: "DISCONNECTED", // Отключена
} as const;

export type IntegrationStatus = (typeof IntegrationStatusTypes)[keyof typeof IntegrationStatusTypes];

export interface SupervisionOrgan {
  id: string;
  name: string;
}

export interface LastAction {
  user: string;
  date: string;
  time: string;
}

export interface IntegrationAttributes {
  connectionId: string; // Идентификатор подключения
  version: string; // Версия
  connectionPath: string; // Путь подключения
  siteUrl?: string; // Сайт (опционально, для обратной совместимости)
}

export interface ActionHistoryItem {
  id: string;
  dateTime: string; // Дата и время в формате "27.03.2024 12:30 GMT+3"
  user: string; // Пользователь
  position?: string; // Должность пользователя
  status: "Подключена" | "Отключена"; // Статус действия
  organName: string; // Название органа Надзора
}

export interface IntegrationCard {
  id: string;
  title?: string; // Опционально, так как в подключенном состоянии показывается название органа
  status: IntegrationStatus;
  selectedOrgan?: SupervisionOrgan;
  integrationId?: string; // Для обратной совместимости
  buildBusEnabled?: boolean; // Шина BuildBus (заменяет integrationBusEnabled)
  restApiEnabled?: boolean; // Оставляем для обратной совместимости, но не используем в UI
  lastAction?: LastAction;
  attributes?: IntegrationAttributes;
  actionHistory?: ActionHistoryItem[]; // История действий
  isEditMode?: boolean; // Режим редактирования (для состояния CONNECTED)
}

